import './bootstrap';
import {createApp} from 'vue';
import {createPinia} from 'pinia'
import { createI18n } from "vue-i18n";
import Notifications from "notiwind";
import LoginVue from "./components/auth/LoginVue.vue"
import ReferalCodeVue from "./components/auth/ReferalCodeVue.vue"
import CompleteRegistrationVue from "./components/auth/CompleteRegistrationVue.vue"
import OrganisationInformationVue from "./components/auth/OrganisationInformationVue.vue"
import PasswordSetupVue from "./components/auth/PasswordSetupVue.vue"
import VerificationCodeVue from "./components/auth/VerificationCodeVue.vue"
import RegisterVue from "./components/auth/RegisterVue.vue"
import PricingPage from "./components/pages/Pricing.vue"

const pinia = createPinia()
const app = createApp({});
const i18n = createI18n({
    legacy: false,
    locale: 'en',
    allowComposition: true,
})

/* components starts */
app.component('login-component', LoginVue); 
app.component('referal-component', ReferalCodeVue); 
app.component('organisation-information', OrganisationInformationVue); 
app.component('passwordsetup-component', PasswordSetupVue); 
app.component('verification-component', VerificationCodeVue); 
app.component('completeregistration-component', CompleteRegistrationVue);
app.component('registration-component', RegisterVue);
app.component('pricing-page', PricingPage);
/* components ends */

if (import.meta.env.PROD) {
    // Disable all console logs in production
    console.log = () => {}
    console.info = () => {}
    console.warn = () => {}
    console.error = () => {}
    console.debug = () => {}
}

app.use(Notifications);
app.use(pinia)
app.use(i18n)
app.mount('#app')
